const tableHeaders = [
  {
    label: 'sender',
    key: 'sender',
    sortable: false,
  },
  {
    label: 'status',
    key: 'status',
    sortable: false,
  },
  {
    label: 'type',
    key: 'globalMessageType',
    sortable: false,
  },
  {
    label: 'priority',
    key: 'priority',
    sortable: false,
  },
  {
    label: 'time-period',
    key: 'period',
    sortable: false,
  },
  {
    label: 'message',
    key: 'globalMessage',
    sortable: false,
  },
  {
    label: 'view-edit',
    key: 'view',
    sortable: false,
  },
  {
    label: 'copy',
    key: 'copy',
    sortable: false,
  },
  {
    label: 'delete',
    key: 'delete',
    sortable: false,
  },
];

export default () => tableHeaders;
